/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, July 2023
 * @format
 * @flow
 */

export default {
  getCustomizeWaitlist: 'api/brands/customize/waitList/brandId/{brandId}/languageId/{languageId}',
  getLanguageWaitlist: 'api/brands/language/waitList/brandId/{brandId}',
};
